module.exports = __webpack_public_path__ + "static/media/sorry.70b0e76e.svg";